module.exports = __webpack_public_path__ + "assets/img/1.4334d167.png";